export const ADMIN_BOSCH = "admin_bosch";
export const ADMIN = "admin";
export const MANAGER = "manager";
export const AGENT = "basic";